import React from "react";

interface AlphabeticalNavigationProps {
  availableLetters: string[];
  activeLetters: string[];
  onLetterClick: (letter: string) => void;
  className?: string;
}

const AlphabeticalNavigation: React.FC<AlphabeticalNavigationProps> = ({
  availableLetters,
  activeLetters,
  onLetterClick,
  className = "",
}) => {
  const allLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  const handleLetterClick = (letter: string) => {
    if (availableLetters.includes(letter)) {
      onLetterClick(letter);
      // Smooth scroll to the letter section
      const element = document.getElementById(`letter-${letter}`);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  };

  return (
    <div
      className={`sticky top-0 z-10 bg-base-100 shadow-sm border-b border-base-300 ${className}`}
    >
      <div className="flex flex-wrap justify-center gap-x-2 gap-y-1 p-4 max-w-4xl mx-auto">
        {allLetters.map((letter) => {
          const isAvailable = availableLetters.includes(letter);
          const isActive = activeLetters.includes(letter);

          return (
            <button
              key={letter}
              onClick={() => handleLetterClick(letter)}
              disabled={!isAvailable}
              className={`w-10 h-10 rounded-full border-2 flex items-center justify-center text-sm font-medium transition-all duration-200 ${
                isActive
                  ? "bg-primary text-primary-content border-primary"
                  : isAvailable
                    ? "border-primary/30 text-primary hover:bg-primary/10 hover:border-primary"
                    : "border-base-300 text-base-content/40 cursor-not-allowed"
              }`}
              title={
                isAvailable
                  ? `Go to countries starting with ${letter}`
                  : `No countries starting with ${letter}`
              }
            >
              {letter}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AlphabeticalNavigation;
